import type { UiModule } from '@krp/client-runtime'

import { scheduleActions } from './actions/registerActions'
import { recentCashiersPersistence } from './features/schedule/model/recentSlice'
import { scheduleUiReducer, type ScheduleUiState } from './reducer'
import { scheduleWindows } from './windows/registerWindows'

export function createScheduleUiModule(): UiModule<ScheduleUiState> {
  return {
    id: 'schedule',
    reducer: scheduleUiReducer,
    slices: [
      { name: 'chosen', lifetime: 'screen', reason: 'кассир, выбранный человеком на экране «По кассирам»; пока он не выбран, экран предлагает кассира открытой смены; месяц — в адресе, объекты, состав и назначения — в кэше запросов, обновление страницы выбор не сохраняет' },
      { name: 'recent', lifetime: 'device', reason: 'последние пять выбранных кассиров для подсказки в поиске: предпочтение человека за этим устройством, только идентификаторы' },
    ],
    windows: scheduleWindows,
    actions: scheduleActions,
    persistence: [recentCashiersPersistence<ScheduleUiState>()],
    listeners: [],
  }
}
